export default __webpack_public_path__ + "static/media/star.aae6ae6f.svg";